#!/usr/bin/env node
import { StdioServerTransport } from '@modelcontextprotocol/sdk/server/stdio.js';
import { createMcpServer, initializeMcpServer } from './core/server.js';
import logger from './utils/logger.js';

/**
 * Main entry point for the STDIO transport version of the MCP server
 */
async function main() {
  try {
    logger.info('Starting Artillery Performance MCP Server with STDIO transport');
    
    // Create and initialize the MCP server
    const server = createMcpServer();
    await initializeMcpServer(server);
    
    // Create and connect the STDIO transport
    const transport = new StdioServerTransport();
    logger.info('Connecting STDIO transport to MCP server');
    
    await server.connect(transport);
    logger.info('MCP server successfully started with STDIO transport');
  } catch (error) {
    logger.error(`Error starting MCP server: ${error}`);
    process.exit(1);
  }
}

// Start the server
main().catch(error => {
  logger.error(`Unhandled error: ${error}`);
  process.exit(1);
});
